import { render } from "./CardItemProxy.vue?vue&type=template&id=a2453b90&ts=true"
import script from "./CardItemProxy.vue?vue&type=script&lang=ts"
export * from "./CardItemProxy.vue?vue&type=script&lang=ts"

import "./CardItemProxy.vue?vue&type=style&index=0&id=a2453b90&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__